import * as getter from '../types/getters'
import * as action from '../types/actions'
import linq from 'linq'
import Paginate from '../../models/Paginate'
import { buildQuery } from '../../utility/stringUtility'
import store from '../../store'
import Order from '../../models/Order'
import News from '../../models/News'

export const state = {
    list: [],
    paginate: new Paginate(),
    detailOrder: new Order(),
}

export const mutations = {
    [action.FETCH_ORDERS](state, list) {
        state.list = list
    },

    [action.UPDATE_ORDERS_PAGINATE](state, paginate) {
        state.paginate = new Paginate(paginate)
    },

    [action.UPDATE_ADMIN_ORDER](state, order) {
        state.detailOrder = new Order({ ...order })
    },
}

export const actions = {
    async [action.FETCH_ORDERS]({ commit }) {
        const query = buildQuery(store.state.route.query)
        const { data } = await axios.get(`/api/orders?${query}`)

        const list = linq
            .from(data.data)
            .select((x) => new Order(x))
            .toArray()
        commit(action.FETCH_ORDERS, list)
        commit(action.UPDATE_ORDERS_PAGINATE, data)
    },

    async [action.FETCH_ADMIN_ORDER]({ commit }) {
        const id = store.state.route.params.id
        const { data } = await axios.get(`/api/order/${id}`)
        commit(action.UPDATE_ADMIN_ORDER, data)
    },

    async [action.UPDATE_ADMIN_ORDER]({ commit }, order) {
        commit(action.UPDATE_ADMIN_ORDER, order)
    },
}

export const getters = {
    [getter.ORDERS]: (state) => state.list,
    [getter.ORDERS_PAGINATE]: (state) => state.paginate,
    [getter.ADMIN_ORDER]: (state) => state.detailOrder,
}

export default {
    state,
    mutations,
    actions,
    getters,
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/orders.js